import { combineReducers } from "redux";
import { ActionSchema } from "../actions";
import { ApiMetricsConst, GetRequestCountDataSchema, GetResponseCodeDataSchema, GetPerformanceDataSchema } from "../actions/apiMetricsActions";

const getRequestCountDataReducer = (state = {}, action: ActionSchema<GetRequestCountDataSchema>) => {
  switch (action.type) {
    case ApiMetricsConst.GET_REQUEST_COUNT_DATA_LOADING:
    case ApiMetricsConst.GET_REQUEST_COUNT_DATA_ERROR:
    case ApiMetricsConst.GET_REQUEST_COUNT_DATA_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const getResponseCodeDataReducer = (state = {}, action: ActionSchema<GetResponseCodeDataSchema>) => {
  switch (action.type) {
    case ApiMetricsConst.GET_RESPONSE_CODE_DATA_LOADING:
    case ApiMetricsConst.GET_RESPONSE_CODE_DATA_ERROR:
    case ApiMetricsConst.GET_RESPONSE_CODE_DATA_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const getPerformanceDataReducer = (state = {}, action: ActionSchema<GetPerformanceDataSchema>) => {
  switch (action.type) {
    case ApiMetricsConst.GET_PERFORMANCE_DATA_LOADING:
    case ApiMetricsConst.GET_PERFORMANCE_DATA_ERROR:
    case ApiMetricsConst.GET_PERFORMANCE_DATA_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const apiMetricsReducer = combineReducers({
  requestCount: getRequestCountDataReducer,
  responseCode: getResponseCodeDataReducer,
  performanceData: getPerformanceDataReducer
});

export interface ApiMetricsSchema {
  requestCount: GetRequestCountDataSchema;
  responseCode: GetResponseCodeDataSchema;
  performanceData: GetPerformanceDataSchema;
}

export default apiMetricsReducer;
